import React, { Component } from "react";
import MUIDataTable from "mui-datatables";
import { createMuiTheme, MuiThemeProvider } from "@material-ui/core/styles";

import axios from "axios";
import Fab from "@material-ui/core/Fab";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import ViewIcon from "@material-ui/icons/Visibility";
import FolderIcon from "@material-ui/icons/Folder";
import CircularProgress from "@material-ui/core/CircularProgress";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Switch from "@material-ui/core/Switch";
import CustomToolbar from "../common/AddButton";
import { FavoriteBorder } from "@material-ui/icons";

import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import Button from "@material-ui/core/Button";
import api from "../common/api";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import PublishIcon from "@material-ui/icons/Publish";
import HistoryIcon from "@material-ui/icons/History";
import SpeedIcon from "@material-ui/icons/Speed";
import AttachMoneyIcon from "@material-ui/icons/AttachMoney";
import History from "../common/vehicles/History";
import Backdrop from "@material-ui/core/Backdrop";
import Typography from "@material-ui/core/Typography";
import VehicleKmSubcontact from "./VehicleKmSubcontact";

class Vehicles extends React.Component {
  constructor() {
    super();

    this.state = {
      data: "",
      isLoaded: false,
      all: false,
      backdrop: false,
      history_dialog: { open: false, plate: "" },
      km_subcontact_dialog: { open: false, plate: "", id: "" },
      vehicles: [],
      userConfigTableState: {
        searchText: "",
        filterList: [],
        columns: []
      },
      dialogTitle: "Vehiculo",
      savedFilters: false
    };

    this.handleDelete = this.handleDelete.bind(this);
  }

  async componentDidMount() {
    await this.getVehicles(this.state.all, true);
  }

  async getVehicles(all, useConfig = false) {
    const token = localStorage.getItem("userToken");
    if (useConfig) {
      await axios
        .get(api.users().getConfig("vehicles"), {
          headers: { Authorization: `Bearer ${token}` }
        })
        .then(res => {
          var user_config = res.data[0];
          if (user_config.value) {
            user_config.value = JSON.parse(user_config.value);
            this.setState({ userConfigTableState: user_config.value });
            if (user_config.value.all) {
              all = user_config.value.all;
              this.setState({ all: user_config.value.all });
            }
          }
        })
        .catch(err => {
          console.log(err);
        });
    }
    all = all ? 1 : 0;
    return axios
      .get(api.vehicles().index(all), {
        headers: { Authorization: `Bearer ${token}` }
      })
      .then(res => {
        this.setState({ isLoaded: true, vehicles: res.data });
      })
      .catch(err => {
        this.setState({ isLoaded: true, vehicles: [] });
      });
  }

  handleAllVehicles = async e => {
    var all = !this.state.all;
    this.setState({ isLoaded: false, all: all, vehicles: [] });
    await this.getVehicles(all);
  };
  handleDelete(e, vehicle) {
    e.preventDefault();
    this.state.vehicles.map((val, idx) => {
      if (val.plate === vehicle) {
        this.setState({ delete_id: val.id });
      }
    });

    var message = "";
    if (vehicle !== "") {
      message =
        "Está a punto de dar de baja al vehiculo " +
        vehicle +
        ". ¿Está seguro?";
    } else {
      message = "Hubo un problema al dar de baja al vehiculo.";
    }
    this.setState({
      message: message,
      dialogOpen: true,
      dialogTitle: "Baja del vehiculo"
    });
  }

  handleRefresh(e) {
    e.preventDefault();
    window.location.href = `/vehicles`;
  }

  handleDialogClose(e) {
    e.preventDefault();
    this.setState({
      dialogOpen: false,
      errors: false,
      message: "",
      delete_id: ""
    });
  }

  handleCloseBackdrop = () => {
    var backdrop = !this.state.backdrop;
    this.setState({ backdrop: backdrop });
  };

  confirmDelete() {
    const token = localStorage.getItem("userToken");
    return axios
      .delete(
        api.vehicles().delete(this.state.delete_id),
        { headers: { Authorization: `Bearer ${token}` } },
        { params: { "vehicle[id]": this.state.delete_id } }
      )
      .then(res => {
        this.setState({ message: "Vehiculo dado de baja con éxito!" });
        this.setState({ errors: false });
        this.setState({ delete_id: "" });
        this.setState({ rowId: "" });
      })
      .catch(err => {
        this.setState({ errors: true });
        this.setState({ delete_id: "" });
        this.setState({ message: err.response.data.errors["vehicle.id"] });
      });
  }

  handleDownload = async () => {
    var formData = new FormData();
    const token = localStorage.getItem("userToken");
    await axios
      .post(api.vehicles().export(), formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`
        }
      })
      .then(response => {
        window.location.href = response.data;
        this.handleCloseBackdrop();
        this.setState({ isLoaded: true });
      })
      .catch(error => {
        alert("Falló la descarga");
        this.setState({ isLoaded: true });
      });
  };

  handleHistoryDialog = (e, plate) => {
    var history_dialog = this.state.history_dialog;
    history_dialog.plate = plate;
    history_dialog.open = !history_dialog.open;
    this.setState({ history_dialog });
  };

  handleKmDialog = (e, plate, id) => {
    var km_subcontact_dialog = this.state.km_subcontact_dialog;
    km_subcontact_dialog.open = !km_subcontact_dialog.open;
    km_subcontact_dialog.plate = km_subcontact_dialog.open ? plate : "";
    km_subcontact_dialog.id = km_subcontact_dialog.open ? id : "";
    this.setState({ km_subcontact_dialog });
  };

  getMuiTheme = () =>
    createMuiTheme({
      overrides: {
        MuiTableCell: {
          root: {
            padding: "0px 8px 0px 8px",
            fontSize: "0.73rem"
          }
        }
      }
    });
  handleSaveFilters = () => {
    this.setState({ savedFilters: false });
    var formData = new FormData();
    var i = 0;
    formData.set("name", "vehicles");
    formData.set("key", "vehicles");
    var config = this.state.userConfigTableState;
    config.all = this.state.all ? 1 : 0;
    config.data = [];
    config.displayData = [];
    formData.set("value", JSON.stringify(config));
    let self = this;
    const token = localStorage.getItem("userToken");
    var dialog = this.state.dialog;
    axios
      .post(api.users().storeConfig(), formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`
        }
      })
      .then(response => {
        self.setState({
          message: "Se han guardado los filtros con éxito!",
          dialogOpen: true,
          dialogTitle: "Vehiculo",
          savedFilters: true
        });
      })
      .catch(error => {
        self.setState({
          message: "Ha ocurrido un error!",
          dialogOpen: true,
          dialogTitle: "Vehiculo",
          savedFilters: true
        });
      });
  };
  handleChange = (action, tableState) => {
    if (action !== "propsUpdate") {
      this.setState({
        userConfigTableState: {
          searchText: tableState.searchText,
          filterList: tableState.filterList,
          columns: tableState.columns
        }
      });
    }
  };

  getColumns = () => {
    const columns = [
      {
        name: "id",
        label: "Id",
        options: {
          filter: false,
          sort: true
        }
      },
      {
        name: "plate",
        label: "Patente",
        options: {
          filter: true,
          filterType: "textField",
          sort: true
        }
      },
      {
        name: "version_full_name.name",
        label: "Descripción",
        options: {
          filter: true,
          filterType: "textField",
          sort: true
          /*customBodyRender: (value, tableMeta, updateValue) => {
          value = tableMeta['rowData'][6] + ' ' +tableMeta['rowData'][7] + ' ' + tableMeta['rowData'][5]
          return value
        }*/
        }
      },
      {
        name: "contract",
        label: "Contrato",
        options: {
          filter: true,
          filterType: "textField",
          sort: true
        }
      },
      {
        name: "contract_id",
        label: "Tipo de Flota",
        options: {
          filter: true,
          filterType: "select",
          sort: true,
          customBodyRender: (value, tableMeta, updateValue) => {
            if (value === "" || value === null || typeof value === undefined) {
              value = "Flota propia";
            } else {
              value = "Flota de terceros";
            }
            return value;
          }
        }
      },
      {
        name: "version.name",
        label: "Version",
        options: {
          display: false
        }
      },
      {
        name: "version.variation.brand.name",
        label: "Marca",
        options: {
          display: false
        }
      },
      {
        name: "version.variation.dnrpa_description",
        label: "Modelo",
        options: {
          display: false
        }
      },
      {
        name: "version.maintenance_plan.id",
        label: "ID Plan MTN",
        options: {
          filter: false,
          sort: false,
          display: false,
          viewColumns: false
        }
      },
      {
        name: "version.maintenance_plan.description",
        label: "Plan de Mantenimiento",
        options: {
          display: false,
          customBodyRender: (value, tableMeta, updateValue) => {
            const maintenance_plan_id = tableMeta.rowData[8];
            return (
              <a href={"/maintenance-plan/" + maintenance_plan_id + "/0"}>
                {value}
              </a>
            );
          }
        }
      },
      {
        name: "state",
        label: "Estado",
        options: {
          display: false,
          filter: "select"
        }
      },
      {
        name: "last_km",
        label: "KM",
        options: {
          filter: false,
          filterType: "textField",
          sort: true
        }
      },
      {
        name: "purchase.request_date",
        label: "Fecha de pedido",
        options: {
          display: false,
          filter: "select"
        }
      },
      {
        name: "purchase.estimated_invoice_date",
        label: "Fecha estimada de factura",
        options: {
          display: false,
          filter: "select"
        }
      },
      {
        name: "purchase.invoice_date",
        label: "Fecha factura",
        options: {
          display: false,
          filter: "select"
        }
      },
      {
        name: "plate_date",
        label: "Fecha patentamiento",
        options: {
          display: false,
          filter: "select"
        }
      },
      {
        name: "purchase.estimated_plate_date",
        label: "Fecha estimada de patentamiento",
        options: {
          display: false,
          filter: "select"
        }
      },
      {
        name: "purchase.payment_date",
        label: "Fecha de pago",
        options: {
          display: false,
          filter: "select"
        }
      },
      {
        name: "purchase.documents_reception_date",
        label: "Fecha de recepcion docs",
        options: {
          display: false,
          filter: "select"
        }
      },
      {
        name: "purchase.plate_delivered_date",
        label: "Fecha de recepcion chapas",
        options: {
          display: false,
          filter: "select"
        }
      },
      {
        name: "purchase.vehicle_delivered_date",
        label: "Fecha de entrega",
        options: {
          display: false,
          filter: "select"
        }
      },
      {
        name: "purchase.estimated_vehicle_delivered_date",
        label: "Fecha estimada de entrega",
        options: {
          display: false,
          filter: "select"
        }
      },
      {
        name: "purchase.invoice_number",
        label: "Nro factura",
        options: {
          display: false,
          filter: "select"
        }
      },
      {
        name: "purchase.due_date",
        label: "Fecha de vencimiento",
        options: {
          display: false,
          filter: "select"
        }
      },
      {
        name: "purchase.price_list",
        label: "Precio lista",
        options: {
          display: false,
          filter: "select"
        }
      },
      {
        name: "purchase.price_buy",
        label: "Precio compra",
        options: {
          display: false,
          filter: "select"
        }
      },
      {
        name: "purchase.client_destiny_business_name",
        label: "Cliente solicitante",
        options: {
          display: false,
          filter: "select"
        }
      },
      {
        name: "sap_dimension",
        label: "Dimension SAP",
        options: {
          display: false,
          filter: false,
          sort: false
        }
      },
      {
        name: "Acciones",
        label: "",
        options: {
          filter: false,
          setCellHeaderProps: () => ({ align: "right" }),
          customBodyRender: (value, tableMeta, updateValue) => {
            const rowId = tableMeta.rowData[0];
            const plate = tableMeta.rowData[1];
            //const rowId = 1
            return (
              <div
                className="row"
                style={{
                  display: "inline-table",
                  textAlign: "right",
                  paddingRight: "20px"
                }}
              >
                <Fab
                  color="primary"
                  aria-label="view"
                  variant="extended"
                  style={{ boxShadow: "none", backgroundColor: "green" }}
                  fontSize="small"
                  className="MuiButtonBase-root MuiFab-sizeSmall mr-1"
                  href={"vehicle/edit/" + rowId}
                >
                  <EditIcon fontSize="small" />
                </Fab>
                <Fab
                  color="secondary"
                  aria-label="edit"
                  variant="extended"
                  style={{ boxShadow: "none" }}
                  fontSize="small"
                  className="MuiButtonBase-root MuiFab-sizeSmall mr-1"
                  href={"vehicle/" + rowId + "/1"}
                >
                  <ViewIcon fontSize="small" />
                </Fab>
                <Fab
                  color="primary"
                  aria-label="view"
                  variant="extended"
                  style={{ boxShadow: "none" }}
                  fontSize="small"
                  className="MuiButtonBase-root MuiFab-sizeSmall mr-1"
                  onClick={e => {
                    this.handleDelete(e, plate);
                  }}
                >
                  <DeleteIcon fontSize="small" />
                </Fab>
                <Fab
                  color="primary"
                  aria-label="view"
                  variant="extended"
                  style={{ boxShadow: "none" }}
                  fontSize="small"
                  className="MuiButtonBase-root MuiFab-sizeSmall mr-1"
                  onClick={e => {
                    this.handleHistoryDialog(e, plate);
                  }}
                >
                  <HistoryIcon fontSize="small" />
                </Fab>
                <Tooltip title="Precios">
                  <Fab
                    color="primary"
                    aria-label="precios"
                    variant="extended"
                    style={{ boxShadow: "none" }}
                    fontSize="small"
                    className="MuiButtonBase-root MuiFab-sizeSmall mr-1"
                    href={"vehicle/" + rowId + "/pricing-history"}
                  >
                    <AttachMoneyIcon fontSize="small" />
                  </Fab>
                </Tooltip>
                <Fab
                  color="primary"
                  aria-label="view"
                  variant="extended"
                  style={{ boxShadow: "none" }}
                  fontSize="small"
                  className="MuiButtonBase-root MuiFab-sizeSmall mr-1"
                  onClick={e => {
                    this.handleKmDialog(e, plate, rowId);
                  }}
                >
                  <SpeedIcon fontSize="small" />
                </Fab>
              </div>
            );
          }
        }
      }
    ];

    const headerNames = [
      {
        name: "id",
        download: true
      },
      {
        name: "plate",
        download: true
      },
      {
        name: "description",
        download: true
      },
      {
        name: "policy_id",
        download: true
      }
    ];
    for (let i = 0; i < columns.length; i++) {
      if (!columns[i].options) {
        columns[i].options = columns[i];
      }
      columns[i].options.filterList = [];
      if (this.state.userConfigTableState.filterList[i]) {
        columns[
          i
        ].options.filterList = this.state.userConfigTableState.filterList[i];
      }
      columns[
        i
      ].options.filterList = this.state.userConfigTableState.filterList[i];
      if (
        this.state.userConfigTableState.columns[i] !== undefined &&
        this.state.userConfigTableState.columns[i].name === columns[i].name
      ) {
        if (
          this.state.userConfigTableState.columns[i].hasOwnProperty("display")
        )
          columns[i].options.display = this.state.userConfigTableState.columns[
            i
          ].display;
        if (
          this.state.userConfigTableState.columns[i].hasOwnProperty(
            "sortDirection"
          )
        ) {
          if (
            this.state.userConfigTableState.columns[i].sortDirection != "none"
          )
            columns[
              i
            ].options.sortDirection = this.state.userConfigTableState.columns[
              i
            ].sortDirection;
        }
      }
    }

    return columns;
  };

  render() {
    var dialog = this.state.dialog;

    const footerNames = [];
    const options = {
      download: true,
      onDownload: () => {
        this.setState({ backdrop: true });
        this.handleDownload();
        return false;
      },
      onTableInit: (action, tableState) => {
        this.setState({ userConfigTableState: tableState });
      },
      onTableChange: (action, tableState) =>
        this.handleChange(action, tableState),
      customToolbar: () => {
        return (
          <React.Fragment>
            <Tooltip title={"Guardar filtros"}>
              <IconButton
                onClick={e => {
                  this.handleSaveFilters(e);
                }}
              >
                <FavoriteBorder />
              </IconButton>
            </Tooltip>
            <Tooltip title={"Importar"}>
              <IconButton
                onClick={e => {
                  window.location.href = "vehicles/0/1/1/import";
                }}
              >
                <PublishIcon />
              </IconButton>
            </Tooltip>
            <Tooltip title={"Subir documentos"}>
              <IconButton
                onClick={e => {
                  window.location.href = "vehicles/import/zip";
                }}
              >
                <FolderIcon />
              </IconButton>
            </Tooltip>
            <Tooltip title={"Inactivos"}>
              <FormControlLabel
                control={
                  <Switch
                    disabled={this.state.isLoaded === false ? true : false}
                    size="small"
                    onChange={e => {
                      this.handleAllVehicles(e);
                    }}
                    value={this.state.all}
                    checked={this.state.all}
                  />
                }
                label={
                  <Typography style={{ fontSize: "0.73rem" }}>
                    Inactivos
                  </Typography>
                }
                labelPlacement="bottom"
                className="m-0 mt-3 mx-1"
              />
            </Tooltip>

            <CustomToolbar url="new" />
          </React.Fragment>
        );
      },
      print: false,
      responsive: "stacked",
      selectableRowsOnClick: true,
      rowsPerPage: 10,
      selectableRows: false,
      textLabels: {
        toolbar: {
          search: "Buscar",
          viewColumns: "Ver columnas",
          filterTable: "Filtros",
          downloadCsv: "Exportar XLS"
        },
        body: {
          noMatch: this.state.isLoaded ? (
            "No hay resultados"
          ) : (
            <CircularProgress />
          )
        },
        selectedRows: {
          text: "fila(s) seleccionadas"
        },
        viewColumns: {
          title: "Ver columnas"
        },
        pagination: {
          next: "Siguiente",
          previous: "Anteior",
          rowsPerPage: "Cantidad por página:",
          displayRows: "de"
        },
        filter: {
          all: "Todos",
          title: "Filtros",
          reset: "Limpiar"
        }
      }
    };

    return (
      <React.Fragment>
        <div>
          <Dialog
            open={this.state.dialogOpen}
            onClose={e => this.handleDialogClose(e)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title">
              {this.state.dialogTitle}
            </DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                {this.state.message}
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              {!this.state.errors ? (
                this.state.savedFilters ? (
                  <div>
                    <Button
                      onClick={e => this.handleRefresh(e)}
                      color="primary"
                    >
                      Continuar
                    </Button>
                  </div>
                ) : this.state.rowId === "" ? (
                  <div>
                    <Button
                      onClick={e => this.handleRefresh(e)}
                      color="primary"
                    >
                      Continuar
                    </Button>
                  </div>
                ) : (
                  <div>
                    <Button
                      onClick={e => this.handleDialogClose(e)}
                      color="primary"
                      autoFocus
                    >
                      Cancelar
                    </Button>
                    <Button
                      onClick={this.confirmDelete.bind(this)}
                      color="primary"
                    >
                      Continuar
                    </Button>
                  </div>
                )
              ) : (
                <div>
                  <Button
                    onClick={e => this.handleDialogClose(e)}
                    color="primary"
                  >
                    Continuar
                  </Button>
                </div>
              )}
            </DialogActions>
          </Dialog>
          <History
            plate={this.state.history_dialog.plate}
            open={this.state.history_dialog.open}
            handleHistoryDialog={this.handleHistoryDialog}
          />
          {this.state.km_subcontact_dialog.plate && (
            <VehicleKmSubcontact
              plate={this.state.km_subcontact_dialog.plate}
              open={this.state.km_subcontact_dialog.open}
              handleKmDialog={this.handleKmDialog}
              id={this.state.km_subcontact_dialog.id}
            />
          )}
        </div>
        <div>
          <MuiThemeProvider theme={this.getMuiTheme()}>
            <Backdrop
              open={this.state.backdrop}
              onClick={this.handleCloseBackdrop}
              style={{ zIndex: 10000, color: "#3f51b5" }}
            >
              <CircularProgress color="inherit" />{" "}
              <Typography className="ml-2" variant="h5" color="primary">
                Descargando...
              </Typography>
            </Backdrop>
            <MUIDataTable
              title="Lista de Vehículos"
              data={Object.values(this.state.vehicles)}
              columns={this.getColumns()}
              options={options}
            />
            <div style={{ textAlign: "right" }}>
              <Button
                variant="contained"
                className="mt-3 ml-1 mr-1"
                color="secondary"
                href={"/contracts"}
              >
                Volver
              </Button>
            </div>
          </MuiThemeProvider>
        </div>
      </React.Fragment>
    );
  }
}

export default Vehicles;
